import {
    FETCH_SMSHISTORY_V2,
    FETCH_SMSHISTORY_SUCCEED_V2,
    FETCH_SMSHISTORY_FAILED_V2,

    UNMOUNT_SMSHISTORY_V2,
    
} from './actionTypes';
import api from '../../utils/api';
//SMSHISTORY
export const fetchSmsHistoryV2 = () => {
    return {
        type: FETCH_SMSHISTORY_V2,
    }
};

export const fetchSmsHistorySucceedV2 = data => {
    return {
        type: FETCH_SMSHISTORY_SUCCEED_V2,
        payload: {
            data: data
        }
    }
};

export const fetchSmsHistoryFailedV2 = error => {
    return {
        type: FETCH_SMSHISTORY_FAILED_V2,
        payload: {
            error: error
        }
    }
};

export const unmountSmsHistoryV2 = () => {
    return {
        type: UNMOUNT_SMSHISTORY_V2
    }
};
/**
 * Fetch SmsHistory
 */
export const fetchSmsHistoryV2Action = (query) => dispatch => {
    dispatch(fetchSmsHistoryV2());
    return api.smsHistory.getSMSHistoryV2(query)
        .then(response => {
            dispatch(fetchSmsHistorySucceedV2(response.data.data));
            return Promise.resolve(response.data);
        })
        .catch(error => {
            dispatch(fetchSmsHistoryFailedV2(error.response.data.errors.message));
            return Promise.reject(error.response)
        });
};

export const unmountSmsHistoryV2Action = () => dispatch => {
    dispatch(unmountSmsHistoryV2())
};


